import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="font-bold">고객센터 070-7114-0418</div>
      <div className="text-muted">평일 10시 - 18시</div>
    </footer>
  );
}

export default Footer;
